module.exports = __webpack_public_path__ + "img/Accounting_Icon.508fff98.png";